import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { useRef } from 'react';

interface ICaShippingLabelModalProps {
  children: any;
  closeWindowPortal: any;
}

const CaShippingLabelWIndow: React.FC<ICaShippingLabelModalProps> = props => {
  const {
    children,
    closeWindowPortal,
  } = props;

  const externalWindow = useRef(
    window.open("", "", "toolbar=no,dialog=yes,width=900,height=500,left=200,top=200")
  );

  const containerEl = document.createElement("div");

  React.useEffect(() => {
    const currentWindow = externalWindow.current;
    return () => currentWindow.close();
  }, []);

  externalWindow.current.document.title = "Canada Shipping Label";
  externalWindow.current.document.body.appendChild(containerEl);
  externalWindow.current.onbeforeunload=() => {
    closeWindowPortal();
  }
    return ReactDOM.createPortal(children, containerEl);
};
export default CaShippingLabelWIndow;